import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { buildsV1Sites } from "../../../../../../Utils/roconConstants";
import { useSelector } from "react-redux";
//mui
import { CircularProgress, Grid2, Tooltip, useMediaQuery } from "@mui/material";
//style
import styles from "./OrgSpaceStyles.module.scss";
//local imports
import IconButton from "../../../../../../GlobalComponents/IconButton/IconButton";
//icons
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { ReactComponent as Sites } from "../../../../../../GlobalAssets/svg/Sites.svg";
import { ReactComponent as CreateSiteSvg } from "../../../../../../GlobalAssets/svg/CreateSite.svg";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { ReactComponent as SiteIcon } from "../../../../AdminAssets/svg/SiteIconBlue.svg";
import { ReactComponent as ClientIcon } from "../../../../AdminAssets/svg/clientOrgs.svg";
import { ReactComponent as Clients } from "../../../../../../GlobalAssets/svg/clientIcon.svg";
import { ReactComponent as Parents } from "../../../../../../GlobalAssets/svg/parentIcon.svg";
import { ReactComponent as Usa } from "../../../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../../../GlobalAssets/svg/IndianSvg.svg";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import {
  blockIfOrgDeleting,
  isOrgDeletionInProgress,
} from "../../../../../../Utils/activatePopup";

function OrganizationSpace(props) {
  const {
    name,
    team,
    sites,
    plan,
    orgName,
    onClick,
    icon: Icon,
    isChild,
    childOrgs,
    imagePath,
    orgId,
    expiry,
    country,
    isDedicated,
    isSingleSite,
    deletionInProgress,
  } = props;

  const navigate = useNavigate();
  const [clientOrgs, setClientOrgs] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
    popupCancelTitle: "",
    popupCancelFunction: () => {},
  });

  const ActivatePopup = (type, message, onConfirm) => {
    if (type === "warning") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: message,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          if (onConfirm) onConfirm();
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  // The quick actions stop propagation, so the card level deletion check never
  // runs for them: block each one on its own.
  const blockedByDeletion = () =>
    blockIfOrgDeleting({ orgId, deletionInProgress }, setPopup);

  const handleDashboard = (orgId, e) => {
    e?.stopPropagation();
    if (blockedByDeletion()) return;
    navigate(`/account/${orgId}/dashboard`);
  };

  const handleSites = (orgId, e) => {
    e?.stopPropagation();
    if (blockedByDeletion()) return;
    navigate(`/account/${orgId}/sites-overview`);
  };

  const handleCreateSite = (orgId, e) => {
    e?.stopPropagation();
    if (blockedByDeletion()) return;
    navigate(`/account/${orgId}/create`);
  };

  const handleBlueprints = (orgId, e) => {
    e?.stopPropagation();
    if (blockedByDeletion()) return;
    navigate(`/account/${orgId}/blueprints`);
  };

  const handleBilling = (orgId, e) => {
    e?.stopPropagation();
    if (blockedByDeletion()) return;
    if (plan) {
      navigate(`/account/${orgId}/billing-overview`);
    } else navigate(`/account/${orgId}/modify-plan`);
  };

  const handleClientSlider = (event) => {
    event?.stopPropagation();
    setClientOrgs(true);
    getStore().dispatch({
      type: Actions.API_FETCH_CHILD_ORGS,
      data: { orgName: name },
    });
  };

  const clientOrgsData = useSelector(
    (state) => state.organizationsInfo?.childOrgs?.data,
  );

  const allOrgs = useSelector(
    (state) => state.organizationsInfo?.dashboardOrg?.data,
  );

  const hasAccess = allOrgs?.some((existingOrg) => existingOrg.orgId === orgId);
  const isplan =
    (plan && isDedicated === true) || (plan && isDedicated === false);

  return (
    <>
      <Grid2
        className={`${styles.container} ${expiry ? styles.expiry : ""}`}
        onClick={onClick}
      >
        {/* <Grid2 className={styles.detailsContainer}> */}
        <Grid2 className={`${!isChild ? styles.parentOrg : styles.childOrg}`}>
          <Grid2 className={styles.iconContainer}>
            {imagePath ? (
              <img
                src={imagePath}
                alt="Organization"
                style={{ width: "124px", height: "124px", borderRadius: "4px" }}
              />
            ) : (
              <Icon className={styles.Icon} />
            )}
          </Grid2>
          <Grid2>
            <Grid2 className={styles.clientContainer}>
              <Grid2 className={styles.name}>{name}</Grid2>
              <Grid2 className={styles.flexBox}>
                {process.env.REACT_APP_TEMP_DOMAIN === "rocondev.com" && (
                  <Grid2 className={styles.countryBox}>
                    {country === "USA" ? (
                      <Usa className={styles.country} />
                    ) : (
                      <Indian className={styles.country} />
                    )}
                  </Grid2>
                )}
                {!isChild && childOrgs > 0 && (
                  <Grid2
                    className={styles.clientIcon}
                    onClick={handleClientSlider}
                  >
                    <Tooltip title={"Clients"}>
                      <ClientIcon />
                    </Tooltip>
                  </Grid2>
                )}
              </Grid2>
            </Grid2>
            <Grid2 className={styles.teamContainer}>
              {sites ? (
                <Grid2 className={styles.planContainer}>
                  <Grid2>
                    <SiteIcon />
                  </Grid2>
                  <Grid2 className={styles.planName}>{sites}</Grid2>
                </Grid2>
              ) : (
                ""
              )}

              <Grid2 className={styles.planContainer}>
                <Grid2 className={styles.plan}>
                  <GroupsOutlinedIcon className={styles.teamIconColor} />
                </Grid2>
                <Grid2 className={styles.planName}>{team}</Grid2>
              </Grid2>
            </Grid2>
            <Grid2 className={styles.planContainer}>
              {!isChild ? (
                <>
                  {plan ? (
                    <>
                      <Grid2 className={styles.plan}>Plan :</Grid2>
                      <Grid2
                        className={`${styles.planName} ${
                          expiry ? styles.planExpried : ""
                        }`}
                      >
                        {expiry ? "Plan Expired" : plan}
                        {process.env.REACT_APP_TEMP_DOMAIN ===
                          "rocondev.com" && (
                          <>
                            {isplan && (
                              <span
                                className={`${
                                  isDedicated === true
                                    ? styles.isPlan
                                    : styles.isPlan1
                                }`}
                              >
                                {isDedicated === true
                                  ? "Dedicated"
                                  : "Kubernetes"}
                              </span>
                            )}
                          </>
                        )}
                      </Grid2>
                    </>
                  ) : (
                    <Grid2 className={styles.planName}>No active plan</Grid2>
                  )}
                </>
              ) : (
                <>
                  {orgName ? (
                    <>
                      <Grid2 className={styles.plan}>Org managed by :</Grid2>
                      <Grid2 className={styles.planName}>{orgName}</Grid2>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </Grid2>
            <Grid2
              className={`${styles.icons} ${
                isChild || isSingleSite ? styles.iconsGap : ""
              }`}
            >
              <IconButton
                icon={DashboardOutlinedIcon}
                tooltipText="Dashboard"
                onClick={(e) => hasAccess && handleDashboard(orgId, e)}
                disabled={!hasAccess}
              />
              <IconButton
                icon={CreateSiteSvg}
                tooltipText="Create site"
                onClick={(e) => hasAccess && handleCreateSite(orgId, e)}
                disabled={!hasAccess}
              />
              <IconButton
                icon={Sites}
                tooltipText="Sites"
                onClick={(e) => hasAccess && handleSites(orgId, e)}
              />
              {/* blueprints copy v1 (EFS) storage: only orgs still building v1 sites, or dedicated */}
              {!isSingleSite && (isDedicated || buildsV1Sites(orgId)) && (
                <IconButton
                  icon={DrawOutlinedIcon}
                  tooltipText="Blueprints"
                  onClick={(e) => hasAccess && handleBlueprints(orgId, e)}
                  disabled={!hasAccess}
                />
              )}
              {!isChild && (
                <IconButton
                  icon={PaidOutlinedIcon}
                  tooltipText={plan ? "Billing" : "Plans"}
                  onClick={(e) => hasAccess && handleBilling(orgId, e)}
                />
              )}
              {/* {!isChild && (
                <IconButton
                  icon={CorporateFareIcon}
                  tooltipText="Clients"
                  onClick={handleClientSlider}
                />
              )} */}
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      {clientOrgs && (
        <SlidingPane
          isOpen={clientOrgs}
          title="Client Organizations"
          from={isMobile ? "bottom" : "right"}
          width={isMobile ? "100%" : "30%"}
          className={`${styles.slidePane} orgSpace`}
          onRequestClose={() => setClientOrgs(false)}
        >
          {clientOrgsData ? (
            <ClientSlider
              clients={clientOrgsData}
              allOrgs={allOrgs}
              setClientOrgs={setClientOrgs}
              ActivatePopup={ActivatePopup}
            />
          ) : (
            <Grid2 className={styles.progress}>
              <CircularProgress size={50} />
            </Grid2>
          )}
        </SlidingPane>
      )}
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}

export const ClientSlider = ({
  clients,
  allOrgs,
  setClientOrgs,
  ActivatePopup,
}) => {
  const navigate = useNavigate();
  const handleClientClick = (org, e) => {
    e?.stopPropagation();
    const existsInAllOrgs = allOrgs?.some(
      (existingOrg) => existingOrg.orgId === org.orgId,
    );
    if (!existsInAllOrgs) {
      setClientOrgs(false);
      ActivatePopup(
        "warning",
        "You don't have access to this organization. Please contact your admin.",
      );
      return;
    }
    if (isOrgDeletionInProgress(org.orgId)) {
      setClientOrgs(false);
      ActivatePopup(
        "warning",
        "This organization is being deleted. You won't be able to access it while the deletion is running.",
      );
      return;
    }
    navigate(`/account/${org.orgId}/dashboard`);
  };

  return (
    <>
      {clients?.length > 0 &&
        clients.map((org) => (
          <Grid2
            className={styles.marginBottom}
            key={org.orgId}
            onClick={() => handleClientClick(org)}
          >
            <OrganizationSpace
              className={styles.orgClient}
              icon={org.parentOrgName === null ? Parents : Clients}
              sites={`${org.numOfSites ? org.numOfSites : 0} Sites`}
              name={org.orgName}
              team={`${org.numOfOrgMembers} Members`}
              plan={org.noOfSites?.length > 0 ? org.noOfSites : 0}
              isChild={true}
              orgId={org.orgId}
              country={org.country}
              isDedicated={org.isDedicated}
            />
          </Grid2>
        ))}
    </>
  );
};

export default OrganizationSpace;
